export default __webpack_public_path__ + "static/media/Gunderland Helm.e0204545.jpg";